import { formatarData } from '@/lib/utils';
import { calcularIdade } from '@/lib/mascaras';
import type { MarcacaoEsus } from './tipos';

/** Campo vazio, como o eSUS imprime. */
export const VAZIO = '---';

export function simNao(valor: boolean | null, descricao?: string | null): string | null {
  if (valor === null) return null;
  if (!valor) return 'NÃO';
  return descricao ? `SIM - ${descricao}` : 'SIM';
}

/** `27/10/2026 07:00:00`, como o eSUS imprime. */
export function dataHoraAtendimento(agendamento: MarcacaoEsus['agendamento']): string | null {
  if (!agendamento.data) return null;
  return `${formatarData(agendamento.data)} ${agendamento.hora ?? ''}`.trim();
}

/** `12/12/1963 - 62 ANO(S)`, com a idade no dia da impressão. */
export function nascimentoComIdade(dataNascimento: string | null): string | null {
  if (!dataNascimento) return null;
  const idade = calcularIdade(dataNascimento);
  return `${formatarData(dataNascimento)}${idade !== null ? ` - ${idade} ANO(S)` : ''}`;
}

// -----------------------------------------------------------------------------
// Formato de impressão
// -----------------------------------------------------------------------------

export type FormatoImpressao = 'a4' | 'termica';

/**
 * Formato pedido na URL (`?formato=`). Sem ele, vale o cupom de 80 mm: é o
 * que a recepção entrega ao paciente. A folha A4 fica a um clique.
 */
export function formatoDaUrl(valor: string | null): FormatoImpressao {
  return valor === 'a4' ? 'a4' : 'termica';
}

// -----------------------------------------------------------------------------
// Chave de confirmação
// -----------------------------------------------------------------------------

/**
 * A chave de confirmação não existe no índice do eSUS: quem imprime a digita,
 * se a tiver. Viaja no estado da navegação, e não na URL, para não ficar no
 * histórico do navegador.
 */
export interface EstadoImpressaoMarcacao {
  chaveConfirmacao: string | null;
}

export const TAMANHO_MAXIMO_CHAVE = 20;

/** Em branco vira `null`: imprime sem a chave. O eSUS a exibe em maiúsculas. */
export function normalizarChave(valor: string): string | null {
  const limpo = valor.trim().toUpperCase().slice(0, TAMANHO_MAXIMO_CHAVE);
  return limpo || null;
}

export function chaveDoEstado(estado: unknown): string | null {
  if (typeof estado !== 'object' || estado === null) return null;
  const chave = (estado as Partial<EstadoImpressaoMarcacao>).chaveConfirmacao;
  return typeof chave === 'string' ? normalizarChave(chave) : null;
}
